import { CustomError, Result, SessionProvider } from 'core/infrastructure';
import { SaleDTO, InvoiceParamsFromPosDTO, BuyerCustomerDTO, Res } from 'core/api';
import { ThemeManager } from 'pos/ui';

import Phone from './ShowCloseDocumentScreen.Phone';
import Tablet from './ShowCloseDocumentScreen.Tablet';
import * as Invoice from './Invoice';
import { CashdrawerFacade } from 'pos/facades';
import { LayoutType } from './ShowCloseDocumentScreen.Common';
import { CustomerDisplay } from 'pos/services';
import { Message, Modal } from 'core/ui-next/modal';

type CloseParams = {
	layout: LayoutType,
	// Son funciones para que los datos estén siempre actualizados
	printDocument?: () => Promise<void>
	getDocument: () => Invoice.Document,
	setCustomer: (customer: BuyerCustomerDTO) => Promise<void>,
	closeDocument: (params: InvoiceParamsFromPosDTO) => Promise<Result<SaleDTO, CustomError>>
};

export default async function closeDocument(params: CloseParams): Promise<Result<SaleDTO>> {

	if (!SessionProvider.getCurrent().AllowCashTransactions) {
		await Message.show(Res.Msg.MSG_CURRENT_POS_DOES_NOT_ALLOW_CASH_TRANSACTIONS());
		return Result.error();
	}

	const isForRefund = params.layout === 'CreateRefund' || params.layout === 'RefundInvoice';
	const paymentOperation = await CashdrawerFacade.createPaymentOperation(isForRefund);
	const Screen = ThemeManager.selectScreen({ Phone, Tablet });

	await CustomerDisplay.displayTotal(params.getDocument().pendingAmount);

	const result = await Modal.show(
		Screen, { layout: params.layout, printDocument: params.printDocument, getDocument: params.getDocument, setCustomer: params.setCustomer, paymentOperation: paymentOperation, onCloseDocument: params.closeDocument });

	if (result.ok)
		await CustomerDisplay.displaySale(result.value);
	else
		// OJO: Aquí sería bueno que si hemos cancelado el cierre de un ticket se usase un displayTicketTotal, porque
		// en el visor de segunda pantalla eso muesrta el contenido del ticket y no sólo el total, pero no tenemos una
		// forma fácil de obtener un TicketDTO, porque puede que estemos cerrando un ticket, un pedido, devolviendo
		// una factura, o facturando varios albaranes a la vez. De momento lo dejamos así.
		await CustomerDisplay.displayTotal(params.getDocument().pendingAmount);

	return result;
}
